import { colors2 } from 'oolib'
import { dataVizColorsLight } from '../../dataviz/common/colors'

const TAG_BG_COLORS = dataVizColorsLight.map((c) => `color-mix(in srgb, ${c} 60%, transparent)`)

// group (e.g. a table column) -> { offset, colors: Map(value -> colour) }, kept for the session
const groups = new Map()

/**
 * Each new value in a group takes the next colour, so colours repeat only once
 * the palette runs out. Each group starts at its own offset, so columns don't line up.
 */
export const getTagColorByValue = (group, value) => {
  if (!groups.has(group)) groups.set(group, { offset: groups.size, colors: new Map() })
  const { offset, colors } = groups.get(group)

  if (!colors.has(value)) colors.set(value, TAG_BG_COLORS[(offset + colors.size) % TAG_BG_COLORS.length])

  // dark text, white is unreadable on the light fills
  return { tagColor: colors.get(value), textColor: colors2.grey80 }
}
